// import React, { useEffect, createContext, useContext, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useLocalStorage } from './useLocalStorage';
// import { useLazyQuery } from '@apollo/client';
// import { VALIDATE_ACCESS_TOKEN_QUERY } from '../graph/UserGraph';
// import { ENDPOINTS } from '../constants';
// import { useMsal, useAccount } from '@azure/msal-react';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   // msal vars
//   const { instance, accounts, inProgress } = useMsal();
//   // getting the account details
//   const account = useAccount(accounts[0] || {});

//   const [isAuthenticated, setIsAuthenticated] = useLocalStorage(
//     'isAuthenticated',
//     null
//   );

//   const navigate = useNavigate();

//   // const [getLazyAccessTokenValidation, lazyAccessTokenValidationResults] =
//   //   useLazyQuery(VALIDATE_ACCESS_TOKEN_QUERY, {
//   //     context: { clientName: 'openHttpLink' },
//   //     fetchPolicy: 'network-only' // Used for first execution
//   //   });

//   useEffect(() => {
//     // let token = localStorage.getItem("access") ? localStorage.getItem("access") : ""
//     // // console.log(token, "this is token")
//     // getLazyAccessTokenValidation({
//     //   variables: {
//     //     token: token
//     //   },
//     //   onCompleted: ((data) => {
//     //     data.validateAccessToken == "Token is valid" ? setIsAuthenticated(true) : setIsAuthenticated(false)
//     //   })
//     // })

//     /**msal code */
//     if (account) {
//       instance
//         .acquireTokenSilent({
//           scopes: ['User.Read'],
//           account: account
//         })
//         .then((response) => {
//           if (response && response.accessToken) {
//             // callMsGraph(response.accessToken).then((result) => {
//             console.log('response: ', result);
//             // setApiData(result)
//             // });
//           }
//         });
//     }

//     if (accounts.length > 0) {
//       setIsAuthenticated(true);
//     } else {
//       setIsAuthenticated(false);
//     }
//   }, [account, instance]);

//   const loginRedirect = async () => {
//     // setIsAuthenticated(true);
//     navigate(`${ENDPOINTS.loginRedirect}`, { replace: true });
//   };

//   const login = async () => {
//     setIsAuthenticated(true);
//     navigate(`${ENDPOINTS.homeUrl}`, { replace: true });
//   };

//   const logout = () => {
//     setIsAuthenticated(null);
//     localStorage.clear();
//     document.cookie =
//       'X-Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
//     navigate(`${ENDPOINTS.loginUrl}`, { replace: true });
//   };

//   const value = useMemo(
//     () => ({
//       isAuthenticated,
//       loginRedirect,
//       login,
//       logout
//     }),
//     [isAuthenticated]
//   );

//   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
// };

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

import React, { useEffect, createContext, useMemo, useContext } from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated
} from '@azure/msal-react';
import useRequestAccessToken from './useRequestAccessToken';
import { ENDPOINTS } from '../constants';
import { MicrosoftSignInButton } from 'src/components/buttons/login/MicrosoftSignInButton';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const getAccessToken = useRequestAccessToken();
  useEffect(() => {
    if (isAuthenticated) {
      getAccessToken();
    }
  }, [isAuthenticated]);

  const loginRedirect = async () => {
    // setIsAuthenticated(true);
    navigate(`${ENDPOINTS.loginRedirect}`, { replace: true });
  };

  const login = async () => {
    setIsAuthenticated(true);
    navigate(`${ENDPOINTS.homeUrl}`, { replace: true });
  };

  const logout = () => {
    setIsAuthenticated(null);
    localStorage.clear();
    document.cookie =
      'X-Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    navigate(`${ENDPOINTS.loginUrl}`, { replace: true });
  };

  const value = useMemo(
    () => ({
      isAuthenticated,
      loginRedirect,
      login,
      logout
    }),
    [isAuthenticated]
  );

  return (
    <>
      {/*TODO: add some loading component */}
      <AuthenticatedTemplate>
        {/* <Login>
          <Routes isAuthenticated={isAuthenticated} />
        </Login> */}
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        {/* <SignInButton /> */}
        <MicrosoftSignInButton />
      </UnauthenticatedTemplate>
    </>
  );
}

export const useAuth = () => {
  return useContext(AuthContext);
};
